import { FC } from 'react';
import { StageStatus } from './ApplicationProgressBox';
import { statusConfig } from './progressBoxData';
// import { uiCheckbox } from 'components/BionicUI/CutCorners';
import BPIcon from 'components/BionicUI/icons/BPIcon';
import { cn } from 'lib/utils';

interface TickBoxProps {
  isChecked?: boolean;
  status: StageStatus;
}

const TickBox: FC<TickBoxProps> = ({ isChecked = false, status }) => {
  return (
    <div className="block relative w-[40px] h-[40px]">
      <div
        className={cn(
          'block absolute right-0 w-[40px] h-[40px] backdrop-blur-md transition-background-color rounded-[9px] border-[1px] border-solid duration-100 ease-in-out z-10',
          isChecked ? statusConfig[status].bg : 'bg-white/[0.08]',
          isChecked ? statusConfig[status].border : 'border-white/30'
          // uiCheckbox.bg
        )}
      />
      {/* <div
        className={cn(
          'block absolute top-0 right-0 w-[40px] h-[40px] rounded-md pointer-events-none bg-gradient-to-b transition-background-color duration-100 ease-in-out z-10',
          isChecked ? statusConfig[status].edge : 'from-white/30 to-white/10',
          'peer-focus-visible:from-white peer-focus-visible:to-white',
          // uiCheckbox.border
        )}
      /> */}
      {isChecked && (
        <div className="grid absolute top-0 left-0 w-full h-full place-content-center z-10">
          <BPIcon
            icon={status === 'rejected' ? 'close' : 'check'}
            className={statusConfig[status].fill}
          />
        </div>
      )}
    </div>
  );
};

export default TickBox;
